/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./dialogStatistics.vue?vue&type=template&id=959b30e8&scoped=true"
import script from "./dialogStatistics.vue?vue&type=script&lang=js"
export * from "./dialogStatistics.vue?vue&type=script&lang=js"
import style0 from "./dialogStatistics.vue?vue&type=style&index=0&id=959b30e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "959b30e8",
  null
  
)

export default component.exports